var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OzOverlay',{class:[
    'overflow-hidden',
    // Push content to bottom of the screen
    'flex',
    'flex-col',
    'justify-end',
    'items-center',
    // Can remove this once Oz page reset has been applied to all pages.
    'font-sans' ],attrs:{"is-spectral":_vm.isScrimSpectral,"scrim":_vm.xScrim ? 'modal' : null,"should-fade-in":_vm.shouldFadeIn},on:{"scrim-click":_vm.scrimClick,"scrim-esc":_vm.scrimEsc}},[_c('div',{ref:"modalContainer",class:[
      {
        'mt-96 min-h-auto w-full': true,
        'h-full': !_vm.autoHeight,
        'overflow-auto flex flex-col': true,
        'modal-container': true,
        'rounded-none': (_vm.fullSize || _vm.draggedToFullSize) && _vm.MIN_TOP_MARGIN === 0,
        'rounded-3xl rounded-br-none rounded-bl-none': (!_vm.fullSize && !_vm.draggedToFullSize) || _vm.MIN_TOP_MARGIN > 0,
        'full-size': _vm.fullSize || _vm.draggedToFullSize,
        'bg-light-ui-100 dark:bg-dark-ui-100': _vm.darkMode === 'auto',
        'bg-light-ui-100 ': _vm.darkMode === false,
        'bg-dark-ui-100': _vm.darkMode === true,
        'pb-safe-inset-bottom': true,
      } ]},[_c('div',{ref:"modalContainerInner",class:[
        {
          'bg-light-ui-100 dark:bg-dark-ui-100': _vm.darkMode === 'auto',
          'bg-light-ui-100 ': _vm.darkMode === false,
          'bg-dark-ui-100': _vm.darkMode === true,
          'min-h-full flex flex-grow flex-col overflow-hidden': true,
        } ]},[_c('div',{ref:"modalContainerInnerWrapper",class:[_vm.isScrollingWholeModal ? 'block' : 'contents', 'pb-0']},[(_vm.xHeader)?_c('header',{ref:"header"},[(_vm.xDrawerHandle)?_c('div',{staticClass:"flex justify-center mb-2 pt-1",attrs:{"id":"tray-expander-controller"}},[_c('div',{staticClass:"rounded w-7 h-1 bg-highway-disabled dark:bg-white-disabled"})]):_vm._e(),_vm._v(" "),_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{ref:"modalBody",class:{
            'h-auto flex flex-grow flex-col p-0 overflow-hidden': true,
            'overflow-y-auto': _vm.fullSize && _vm.shouldFullSizeCoverScreen,
          },on:{"touchstart":_vm.handleTrayScrollStart,"touchmove":_vm.handleTrayScroll,"touchend":function($event){return _vm.$emit('dragend')}}},[_c('div',{ref:"modalBodyContent"},[_vm._t("body")],2)])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }